(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-swipe"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pcswipeInit) return;
  window.__pcswipeInit = true;

  // ── Init pour chaque carrousel ─────────────────
  function initCarousel(root) {
    const track  = root.querySelector('[data-pcswipe-track]');
    const dots   = root.querySelectorAll('[data-pcswipe-dot]');
    const link   = root.querySelector('.pcswipe__track-link');

    if (!track) return;

    const slideCount = track.querySelectorAll('[data-pcswipe-slide]').length;
    if (slideCount <= 1) return;

    // ── IntersectionObserver : sync dots ──────────
    let activeIndex = 0;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const idx = parseInt(entry.target.dataset.pcswipeSlide, 10);
          if (idx !== activeIndex) {
            activeIndex = idx;
            syncDots(idx);
          }
        }
      });
    }, {
      root: track,
      threshold: 0.5
    });

    track.querySelectorAll('[data-pcswipe-slide]').forEach(slide => observer.observe(slide));

    function syncDots(idx) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('pcswipe__dot--active', i === idx);
      });
    }

    // ── Drag souris desktop ────────────────────────
    let isDragging  = false;
    let startX      = 0;
    let scrollStart = 0;
    let didDrag     = false;

    track.addEventListener('mousedown', (e) => {
      isDragging  = true;
      didDrag     = false;
      startX      = e.clientX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const delta = startX - e.clientX;
      if (Math.abs(delta) > 4) didDrag = true;
      track.scrollLeft = scrollStart + delta;
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      // Re-active pointer-events après drag
      track.style.pointerEvents = '';
    });

    // ── Empêche navigation si drag ─────────────────
    link && link.addEventListener('click', (e) => {
      if (didDrag) {
        e.preventDefault();
        didDrag = false;
      }
    });
  }

  // ── Init au chargement ─────────────────────────
  function initAll() {
    document.querySelectorAll('[data-pcswipe]').forEach(initCarousel);
  }

  // Support section rendering API (ajout dynamique de cartes)
  document.addEventListener('shopify:section:load', initAll);
  // Support Infinite scroll / pagination dynamique
  const listObserver = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-pcswipe]')) initCarousel(node);
        node.querySelectorAll && node.querySelectorAll('[data-pcswipe]').forEach(initCarousel);
      });
    });
  });

  listObserver.observe(document.body, { childList: true, subtree: true });

  // Init initiale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__acdInit) return;
  window.__acdInit = true;

  // ── Scroll lock CSS (injecté une fois) ────────
  const lockStyle = document.createElement('style');
  lockStyle.textContent = `
    .acd-scroll-locked { overflow: hidden; }
    @media screen and (min-width: 750px) {
      .acd-scroll-locked { padding-inline-end: var(--scrollbar-width, 0px); }
    }
  `;
  document.head.appendChild(lockStyle);

  // ── Announcement bar offset ───────────────────
  function getAnnounceOffset() {
    const bar = document.querySelector('.announcement-bar');
    if (!bar) return 0;
    const rect = bar.getBoundingClientRect();
    // Si la barre est visible (pas scrollée hors écran)
    return rect.bottom > 0 ? Math.round(rect.bottom) : 0;
  }

  // ── Hoist to body ─────────────────────────────
  // Déplace le drawer sur <body> pour sortir de tout stacking context
  // (header sticky, sections avec z-index, icônes navigation…)
  function hoistToBody(drawer) {
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  // ── Open / Close ──────────────────────────────
  function openDrawer(drawer, tabIndex) {
    hoistToBody(drawer);
    drawer.removeAttribute('hidden');
    drawer.classList.add('acd-drawer--animating');

    // Mesure la barre d'annonces au moment de l'ouverture
    const offset = getAnnounceOffset();
    const panel = drawer.querySelector('.acd-drawer__panel');
    if (panel) panel.style.setProperty('--acd-announce-offset', offset + 'px');

    requestAnimationFrame(() => requestAnimationFrame(() => {
      drawer.classList.add('acd-drawer--open');
      activateTab(drawer, tabIndex ?? 0);
      focusPanel(drawer);
      lockScroll();
    }));
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('acd-drawer--open');
    const panel = drawer.querySelector('.acd-drawer__panel');

    panel.addEventListener('transitionend', function handler() {
      drawer.classList.remove('acd-drawer--animating');
      drawer.setAttribute('hidden', '');
      unlockScroll();
      restoreFocus();
      panel.removeEventListener('transitionend', handler);
    }, { once: true });
  }

  function activateTab(drawer, index) {
    const tabs   = [...drawer.querySelectorAll('.acd-drawer__tab')];
    const panels = [...drawer.querySelectorAll('.acd-drawer__panel-content')];
    const idx    = Math.max(0, Math.min(index, tabs.length - 1));

    tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === idx ? 'true' : 'false'));
    panels.forEach((panel, i) => {
      i === idx ? panel.removeAttribute('hidden') : panel.setAttribute('hidden', '');
    });

    const body = drawer.querySelector('.acd-drawer__body');
    if (body) body.scrollTop = 0;
  }

  // ── Scroll lock ───────────────────────────────
  function lockScroll()   { document.body.classList.add('acd-scroll-locked'); }
  function unlockScroll() { document.body.classList.remove('acd-scroll-locked'); }

  // ── Focus trap ────────────────────────────────
  let prevFocus = null;

  function focusPanel(drawer) {
    prevFocus = document.activeElement;
    const panel = drawer.querySelector('.acd-drawer__panel');
    if (panel) panel.focus();
    document.addEventListener('keydown', onKeyDown);
  }

  function restoreFocus() {
    document.removeEventListener('keydown', onKeyDown);
    if (prevFocus) { prevFocus.focus(); prevFocus = null; }
  }

  function getFocusable(el) {
    return [...el.querySelectorAll(
      'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )].filter(e => !e.closest('[hidden]') && e.offsetParent !== null);
  }

  function onKeyDown(e) {
    const drawer = document.querySelector('.acd-drawer--open');
    if (!drawer) return;

    if (e.key === 'Escape') { closeDrawer(drawer); return; }
    if (e.key !== 'Tab') return;

    const focusable = getFocusable(drawer);
    if (!focusable.length) return;

    if (e.shiftKey && document.activeElement === focusable[0]) {
      e.preventDefault(); focusable[focusable.length - 1].focus();
    } else if (!e.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
      e.preventDefault(); focusable[0].focus();
    }
  }

  // ── Event delegation ──────────────────────────
  document.addEventListener('click', function (e) {
    // Ouvrir via bouton accordéon
    const trigger = e.target.closest('[data-acd-open]');
    if (trigger) {
      const id     = trigger.dataset.acdOpen;
      const tab    = parseInt(trigger.dataset.acdTab ?? '0', 10);
      const drawer = document.getElementById(id);
      if (drawer) openDrawer(drawer, tab);
      return;
    }

    // Ouvrir via lien "Voir plus" (data-open-accordion="0")
    const voirPlus = e.target.closest('[data-open-accordion]');
    if (voirPlus) {
      e.preventDefault();
      const tab = parseInt(voirPlus.dataset.openAccordion ?? '0', 10);
      // Find the first acd-drawer on the page
      const drawer = document.querySelector('.acd-drawer');
      if (drawer) openDrawer(drawer, tab);
      return;
    }

    // Fermer
    const closer = e.target.closest('[data-acd-close]');
    if (closer) {
      const id     = closer.dataset.acdClose;
      const drawer = document.getElementById(id);
      if (drawer) closeDrawer(drawer);
      return;
    }

    // Changer d'onglet
    const tab = e.target.closest('.acd-drawer__tab');
    if (tab) {
      const drawer = tab.closest('.acd-drawer');
      if (drawer) activateTab(drawer, parseInt(tab.dataset.acdTab, 10));
    }
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-cross-sell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var root = document.querySelector('[data-cart-cs]');
    if (!root) return;

    var track    = root.querySelector('[data-ccs-track]');
    var barsWrap = root.querySelector('[data-ccs-bars]');
    var counter  = root.querySelector('[data-ccs-counter]');
    var emptyEl  = root.querySelector('[data-ccs-empty]');
    var slides   = Array.from(root.querySelectorAll('[data-ccs-slide]'));

    /* ── 1. Filter out products already in cart ── */
    function filterCartItems() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartProductIds = cart.items.map(function(item) {
            return item.product_id;
          });

          var visibleCount = 0;

          slides.forEach(function(slide) {
            var pid = parseInt(slide.dataset.productId, 10);
            if (cartProductIds.indexOf(pid) !== -1) {
              slide.hidden = true;
            } else {
              slide.hidden = false;
              visibleCount++;
            }
          });

          root.setAttribute('data-visible', visibleCount);

          if (visibleCount === 0) {
            emptyEl.hidden = false;
          } else {
            emptyEl.hidden = true;
            buildBars(visibleCount);
            syncIndicator();
          }
        })
        .catch(function() {
          /* On error, show all products */
          root.setAttribute('data-visible', slides.length);
          buildBars(slides.length);
        });
    }

    /* ── 2. Build pagination bars ── */
    function buildBars(count) {
      barsWrap.innerHTML = '';
      if (count <= 1) return;

      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.className = 'cart-cs__bar' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('data-ccs-bar', i);
        btn.setAttribute('type', 'button');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.addEventListener('click', (function(idx) {
          return function() { scrollToVisible(idx); };
        })(i));
        barsWrap.appendChild(btn);
      }
    }

    /* ── 3. Scroll to Nth visible slide ── */
    function scrollToVisible(idx) {
      var visible = slides.filter(function(s) { return !s.hidden; });
      if (visible[idx]) {
        track.scrollTo({ left: visible[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    }

    /* ── 4. Sync bars + counter on scroll ── */
    var activeIdx = 0;

    function syncIndicator() {
      var visible = slides.filter(function(s) { return !s.hidden; });
      if (visible.length <= 1) return;

      var idx = 0;
      var scrollLeft = track.scrollLeft;
      visible.forEach(function(s, i) {
        if (Math.abs((s.offsetLeft - track.offsetLeft) - scrollLeft) < s.offsetWidth / 2) {
          idx = i;
        }
      });

      if (idx !== activeIdx) {
        activeIdx = idx;
        var bars = barsWrap.querySelectorAll('.cart-cs__bar');
        bars.forEach(function(b, i) {
          b.classList.toggle('is-active', i === idx);
        });
      }

      if (counter) {
        counter.textContent = (activeIdx + 1) + ' / ' + visible.length;
      }
    }

    track.addEventListener('scroll', function() {
      requestAnimationFrame(syncIndicator);
    }, { passive: true });

    /* ── 5. Variant select ── */
    root.querySelectorAll('[data-ccs-select]').forEach(function(sel) {
      var slide = sel.closest('[data-ccs-slide]');
      var atc = slide.querySelector('[data-ccs-atc]');

      sel.addEventListener('change', function() {
        if (sel.value) {
          atc.dataset.variantId = sel.value;
        }
      });
    });

    /* ── 6. ATC → add to cart + refresh page ── */
    root.querySelectorAll('[data-ccs-atc]').forEach(function(atc) {
      atc.addEventListener('click', function() {
        var variantId = atc.dataset.variantId;
        var label = atc.querySelector('[data-ccs-atc-label]');
        var originalText = label.textContent;

        atc.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart error');

          atc.classList.add('is-added');
          label.textContent = '✓ Ajouté';

          /* Refresh cart page after short feedback */
          setTimeout(function() {
            window.location.reload();
          }, 800);
        })
        .catch(function(err) {
          console.error('[cart-cs]', err);
          label.textContent = 'Erreur';
          setTimeout(function() {
            label.textContent = originalText;
            atc.disabled = false;
          }, 2000);
        });
      });
    });

    /* ── Init ── */
    filterCartItems();

    /* Re-filter if cart is updated externally */
    document.addEventListener('cart:updated', filterCartItems);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cross-sell"] && !Shopify.designMode) return;
  try {
    (function() {
    function init() {
      var root = document.querySelector('[data-cross-sell]');
      if (!root || root._csInit) return;
      root._csInit = true;

      var track   = root.querySelector('[data-cs-track]');
      var bars    = root.querySelectorAll('[data-cs-bar]');
      var counter = root.querySelector('[data-cs-counter]');
      var count   = parseInt(root.dataset.count, 10);

      var activeIndex = 0;

      function syncIndicator() {
        if (!track.offsetWidth) return;
        var idx = Math.round(track.scrollLeft / track.offsetWidth);
        if (idx === activeIndex) return;
        activeIndex = idx;

        bars.forEach(function(bar, i) {
          bar.classList.toggle('is-active', i === idx);
        });

        if (counter) {
          counter.textContent = (idx + 1) + ' / ' + count;
        }
      }

      track.addEventListener('scroll', syncIndicator, { passive: true });

      bars.forEach(function(bar) {
        bar.addEventListener('click', function() {
          var idx = parseInt(bar.dataset.csBar, 10);
          track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
        });
      });

      root.querySelectorAll('[data-cs-variant-select]').forEach(function(select) {
        var slide = select.closest('[data-cs-slide]');
        var atc   = slide.querySelector('[data-cs-atc]');

        select.addEventListener('change', function() {
          if (select.value) {
            atc.dataset.variantId = select.value;
            atc.disabled = false;
            atc.setAttribute('data-ready', '');
            select.classList.add('has-value');
          }
        });
      });

      /* ATC — JSON body with sections for Horizon speed */
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function(c) {
        if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
      });
      var sectionsParam = sectionIds.join(',');

      root.querySelectorAll('[data-cs-atc]').forEach(function(atc) {
        atc.addEventListener('click', function() {
          if (!atc.hasAttribute('data-ready')) return;

          var variantId = atc.dataset.variantId;
          var label = atc.querySelector('[data-cs-atc-label]');
          var originalText = label.textContent;

          /* Instant visual feedback */
          atc.disabled = true;
          label.textContent = '···';

          var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
          if (sectionsParam) body.sections = sectionsParam;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          })
          .then(function(res) { return res.json(); })
          .then(function(data) {
            if (data.status) throw new Error(data.description || 'Erreur');

            label.textContent = '✓ Ajouté';
            atc.classList.add('is-added');

            /* Dispatch cart:update — Horizon morphs drawer instantly with sections HTML */
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: 'cross-sell',
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  sections: data.sections || {}
                }
              }
            }));

            setTimeout(function() {
              atc.classList.remove('is-added');
              label.textContent = originalText;
              atc.disabled = false;
            }, 1600);
          })
          .catch(function(err) {
            console.error('[cross-sell]', err);
            label.textContent = 'Erreur';
            setTimeout(function() {
              label.textContent = originalText;
              atc.disabled = false;
            }, 2000);
          });
        });
      });
    }

    /* Run immediately if DOM ready, otherwise wait */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["preorder-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    function initCountdown(block) {
      if (block.hasAttribute('data-countdown-init')) return;
      block.setAttribute('data-countdown-init', 'true');

      const dateStr = block.getAttribute('data-release-date');
      if (!dateStr) return;

      const target = new Date(dateStr).getTime();
      const daysEl = block.querySelector('[data-days]');
      const hoursEl = block.querySelector('[data-hours]');
      const minutesEl = block.querySelector('[data-minutes]');
      const secondsEl = block.querySelector('[data-seconds]');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      function pad(n) { return String(n).padStart(2, '0'); }

      function update() {
        const now = Date.now();
        const diff = target - now;

        if (diff <= 0) {
          block.setAttribute('data-expired', 'true');
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);

        requestAnimationFrame(() => setTimeout(update, 1000));
      }

      update();
    }

    function init() {
      document.querySelectorAll('.preorder-block[data-release-date]').forEach(initCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    const observer = new MutationObserver(() => {
      document.querySelectorAll('.preorder-block[data-release-date]:not([data-countdown-init])').forEach(initCountdown);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-card-swipe"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pcswipeInit) return;
  window.__pcswipeInit = true;

  // ── Init pour chaque carrousel ─────────────────
  function initCarousel(root) {
    const track  = root.querySelector('[data-pcswipe-track]');
    const dots   = root.querySelectorAll('[data-pcswipe-dot]');
    const link   = root.querySelector('.pcswipe__track-link');

    if (!track) return;

    const slideCount = track.querySelectorAll('[data-pcswipe-slide]').length;
    if (slideCount <= 1) return;

    // ── IntersectionObserver : sync dots ──────────
    let activeIndex = 0;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const idx = parseInt(entry.target.dataset.pcswipeSlide, 10);
          if (idx !== activeIndex) {
            activeIndex = idx;
            syncDots(idx);
          }
        }
      });
    }, {
      root: track,
      threshold: 0.5
    });

    track.querySelectorAll('[data-pcswipe-slide]').forEach(slide => observer.observe(slide));

    function syncDots(idx) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('pcswipe__dot--active', i === idx);
      });
    }

    // ── Drag souris desktop ────────────────────────
    let isDragging  = false;
    let startX      = 0;
    let scrollStart = 0;
    let didDrag     = false;

    track.addEventListener('mousedown', (e) => {
      isDragging  = true;
      didDrag     = false;
      startX      = e.clientX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const delta = startX - e.clientX;
      if (Math.abs(delta) > 4) didDrag = true;
      track.scrollLeft = scrollStart + delta;
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      // Re-active pointer-events après drag
      track.style.pointerEvents = '';
    });

    // ── Empêche navigation si drag ─────────────────
    link && link.addEventListener('click', (e) => {
      if (didDrag) {
        e.preventDefault();
        didDrag = false;
      }
    });
  }

  // ── Init au chargement ─────────────────────────
  function initAll() {
    document.querySelectorAll('[data-pcswipe]').forEach(initCarousel);
  }

  // Support section rendering API (ajout dynamique de cartes)
  document.addEventListener('shopify:section:load', initAll);
  // Support Infinite scroll / pagination dynamique
  const listObserver = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-pcswipe]')) initCarousel(node);
        node.querySelectorAll && node.querySelectorAll('[data-pcswipe]').forEach(initCarousel);
      });
    });
  });

  listObserver.observe(document.body, { childList: true, subtree: true });

  // Init initiale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
  } catch(e) { console.error(e); }
})();

})();
